import { render, staticRenderFns } from "./fulfillment-employer-row.vue?vue&type=template&id=70f4f37a"
import script from "./fulfillment-employer-row.vue?vue&type=script&lang=js"
export * from "./fulfillment-employer-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports